import { render, staticRenderFns } from "./CompetitionYearHeader.vue?vue&type=template&id=9591d4ac&"
import script from "./CompetitionYearHeader.vue?vue&type=script&lang=js&"
export * from "./CompetitionYearHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports